import React, { Component } from 'react';

export default class UpdateInvoiceModal extends Component {
    constructor(props) {
        super(props);
    }

    postAction = () => {
        axios
            .post(`/invoices/${this.props.invoice.id}/update`)
            .then(() => {
                toastr.success('Invoice udpated successfully');
                window.location.reload();
            })
            .catch(() => {
                toastr.error('Something went wrong');
            });
    };

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>Update Invoice</h4>
                        <hr />
                        <p>
                            Invoice {this.props.invoice.id}
                            {this.props.invoice.invoice_identifier &&
                                ` (${this.props.invoice.invoice_identifier})`}{' '}
                            will be updated with pending reviewed jobs
                        </p>
                        <p>If Active Invoice is sent, the invoice will be sent if reviewed.</p>
                        <div className="form-group">
                            <button className="btn btn-cw-primary ml-2" onClick={this.postAction}>
                                Update Invoice
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="admin-modal-notes-footer">
                        <button className="btn btn-cw-primary ml-2" onClick={this.props.onHide}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
